<template>
  <div class="flex flex-col items-center space-y-3">
    <Cropper
      ref="cropperRef"
      :src="avatar"
      :stencil-component="CircleStencil"
      :stencil-props="{ aspectRatio: 1 / 1 }"
    />
    <div class="flex items-center space-x-3">
      <UButton
        icon="carbon:rotate"
        size="sm"
        color="gray"
        @click="onRotate(90)"
      />
      <UButton
        icon="carbon:rotate-180"
        size="sm"
        color="gray"
        @click="onRotate(-90)"
      />
    </div>
    <div>
      <UInput
        type="file"
        size="sm"
        icon="heroicons:photo"
        accept="image/*"
        @input="onInput"
      />
      <div class="mt-2 text-xs text-gray-500">Ukuran maksimal tidak lebih dari 2 MB</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Cropper, CircleStencil, type CropperResult } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

const props = defineProps<{ initialAvatar: string }>()

const cropperRef = ref()
const avatar = ref(props.initialAvatar)

const { add: addToast } = useToast()

const onRotate = (deg: number) => cropperRef.value.rotate(deg)
const onInput = (e: Event) => {
  const input = e.target as HTMLInputElement

  if (input.files && input.files[0]) {
    if (input.files[0].size > 2 * 1024 * 1024) {
      addToast({
        color: 'red',
        title: 'Ukuran File Melebihi Batas',
        description: 'Ukuran file tidak boleh melebihi 2MB.'
      })

      return
    }

    if (input.files[0].type !== 'image/png') {
      addToast({
        color: 'red',
        title: 'Format File Tidak Didukung',
        description: 'Hanya file berformat PNG yang diperbolehkan.'
      })
      return
    }

    const file = input.files[0]
    avatar.value = URL.createObjectURL(file)
  }
}

const getAvatar = async (): Promise<{ file: File; base: string }> => {
  const { canvas }: CropperResult = cropperRef.value.getResult()

  const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/png'))

  if (!blob) throw new Error('Canvas to Blob conversion failed')

  return {
    file: new File([blob], 'avatar.png', { type: 'image/png' }),
    base: canvas.toDataURL('image/png')
  }
}

defineExpose({ getAvatar })
</script>
